export const passwordRequirementRules = [
  { key: 'length',    label: 'At least 8 characters', test: (v) => v.length >= 8 },
  { key: 'uppercase', label: 'One uppercase letter',  test: (v) => /[A-Z]/.test(v) },
  { key: 'lowercase', label: 'One lowercase letter',  test: (v) => /[a-z]/.test(v) },
  { key: 'number',    label: 'One number',            test: (v) => /\d/.test(v) },
  { key: 'special',   label: 'One special character', test: (v) => /[^A-Za-z0-9]/.test(v) }
];

export function passwordRequirementState(password = '') {
  return passwordRequirementRules.map((rule) => ({ ...rule, met: rule.test(password) }));
}

export function passwordStrength(password = '') {
  const requirements = passwordRequirementState(password);
  const metCount = requirements.filter((r) => r.met).length;
  if (!password) return { key: 'empty',  label: 'Password strength', score: 0,         ratio: 0,    requirements };
  if (metCount <= 2) return { key: 'weak',   label: 'Weak',              score: metCount, ratio: 0.34, requirements };
  if (metCount <= 4) return { key: 'medium', label: 'Getting stronger',  score: metCount, ratio: 0.67, requirements };
  return                   { key: 'strong', label: 'Strong',            score: metCount, ratio: 1,    requirements };
}

export function isStrongPassword(password = '') {
  return passwordRequirementState(password).every((r) => r.met);
}
